import {Injectable} from '@angular/core';
import {Observable, throwError} from "rxjs";
import {applicationUrls} from "../../../shared/application-constants/application-urls.const";
import {HttpClient, HttpErrorResponse, HttpParams} from "@angular/common/http";
import {catchError} from "rxjs/operators";
import {TamGenericSearch} from "../models/tam-generic-search.model";

interface VersionSuggestionResponse {
  title: string;
  suggestedVersion: string;
}

@Injectable({
  providedIn: 'root'
})
export class CblmService {

  private apiUrl = applicationUrls;

  constructor(private httpClient: HttpClient) {
  }


  private handleError<T>(operation?: string, result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      console.error(`${operation} failed: ${error.message}`);
      return throwError(() => new Error(error.message || 'An unknown error occurred'));
    };
  }


  // done
  createGenericCompetency(data: any): Observable<any> {
    return this.httpClient.post<any>(this.apiUrl.genericCompetency.save, data).pipe(
      catchError(this.handleError<any>('data'))
    );
  }

  // done
  getGenericCompetencyDropdown() {
    return this.httpClient.get<any>(this.apiUrl.genericCompetency.getAll).pipe(
      catchError(this.handleError<any>('data'))
    );
  }

  // done
  createSectorSpecificCompetency(data: any): Observable<any> {
    return this.httpClient.post<any>(this.apiUrl.sectorCompetency.save, data).pipe(
      catchError(this.handleError<any>('data'))
    );
  }


  // done
  getSectorCompetencyDropdown() {
    return this.httpClient.get<any>(this.apiUrl.sectorCompetency.getAll).pipe(
      catchError(this.handleError<any>('data'))
    );
  }


  // done
  createOccupationSpecificCompetency(data: any): Observable<any> {
    return this.httpClient.post<any>(this.apiUrl.occupationCompetency.save, data).pipe(
      catchError(this.handleError<any>('data'))
    );
  }

  // done
  getOccupationCompetencyDropdown() {
    return this.httpClient.get<any>(this.apiUrl.occupationCompetency.getAll).pipe(
      catchError(this.handleError<any>('data'))
    );
  }

  // done
  getOccupationSpecificCompetencyList(searchCriteria: TamGenericSearch) {
    return this.httpClient.post<any>(this.apiUrl.occupationCompetency.getAllPage, searchCriteria).pipe(
      catchError(this.handleError<any>('data'))
    );
  }

  getArchiveOccupationSpecificCompetencyList(searchCriteria: TamGenericSearch) {
    return this.httpClient.post<any>(this.apiUrl.occupationCompetency.readArchiveoccupationSpecificCompetency, searchCriteria).pipe(
      catchError(this.handleError<any>('data'))
    );
  }


  // done
  getGenericCompetencyList(searchCriteria: TamGenericSearch) {
    return this.httpClient.post<any>(this.apiUrl.genericCompetency.getAllPage, searchCriteria).pipe(
      catchError(this.handleError<any>('data'))
    );
  }

  // done
  getArchiveGenericCompetencyList(searchCriteria: TamGenericSearch) {
    return this.httpClient.post<any>(this.apiUrl.genericCompetency.readArchiveGenericCompetencyList, searchCriteria).pipe(
      catchError(this.handleError<any>('data'))
    );
  }

  // done
  getSectorSpecificCompetencyList(searchCriteria: TamGenericSearch) {
    return this.httpClient.post<any>(this.apiUrl.sectorCompetency.getAllPage, searchCriteria).pipe(
      catchError(this.handleError<any>('data'))
    );
  }

  getArchiveSectorSpecificCompetencyList(searchCriteria: TamGenericSearch) {
    return this.httpClient.post<any>(this.apiUrl.sectorCompetency.readArchiveSpecificCompetencyList, searchCriteria).pipe(
      catchError(this.handleError<any>('data'))
    );
  }


  getCBLMAttachments(body: any) {
    return this.httpClient.post<any>(this.apiUrl.cblmAttachments.search, body).pipe(
      catchError(this.handleError<any>('data'))
    );
  }

  getGenericVersionSuggestion(title: string): Observable<VersionSuggestionResponse> {
    const params = new HttpParams().set('title', title);
    return this.httpClient
      .get<VersionSuggestionResponse>(this.apiUrl.genericCompetency.version, { params })
      .pipe(
        catchError(this.handleError<VersionSuggestionResponse>('getGenericVersionSuggestion'))
      );
  }


  getSectorVersionSuggestion(title: string): Observable<VersionSuggestionResponse> {
    const params = new HttpParams().set('title', title);
    return this.httpClient
      .get<VersionSuggestionResponse>(this.apiUrl.sectorCompetency.version, { params })
      .pipe(
        catchError(this.handleError<VersionSuggestionResponse>('getGenericVersionSuggestion'))
      );
  }


  getOccupationVersionSuggestion(sector: string, occupation: string): Observable<VersionSuggestionResponse> {
    const params = new HttpParams().set('sector', sector).set('occupation', occupation);
    return this.httpClient
      .get<VersionSuggestionResponse>(this.apiUrl.occupationCompetency.version, { params })
      .pipe(
        catchError(this.handleError<VersionSuggestionResponse>(
          'getSectorOccupationVersionSuggestion'
        ))
      );
  }









// unused calls, will use later
  updateGenericCompetency(id: any, data: any): Observable<any> {
    return this.httpClient.post<any>(this.apiUrl.genericCompetency.save, data).pipe(
      catchError(this.handleError<any>('data'))
    );
  }


  getGenericCompetencyById(id: string | null) {
    return this.httpClient.post<any>(this.apiUrl.genericCompetency.save, id).pipe(
      catchError(this.handleError<any>('data'))
    );
  }


  updateSectorSpecificCompetency(id: any, data: any): Observable<any> {
    return this.httpClient.post<any>(this.apiUrl.genericCompetency.save, data).pipe(
      catchError(this.handleError<any>('data'))
    );
  }


  getSectorSpecificCompetencyById(id: string | null) {
    return this.httpClient.post<any>(this.apiUrl.genericCompetency.save, id).pipe(
      catchError(this.handleError<any>('data'))
    );
  }


  updateOccupationSpecificCompetency(id: any, data: any): Observable<any> {
    return this.httpClient.post<any>(this.apiUrl.genericCompetency.save, data).pipe(
      catchError(this.handleError<any>('data'))
    );
  }

  getOccupationSpecificCompetencyById(id: string | null) {
    return this.httpClient.post<any>(this.apiUrl.genericCompetency.save, id).pipe(
      catchError(this.handleError<any>('data'))
    );
  }


  deleteGenericCompetency(id: string) {
    return this.httpClient.post<any>(this.apiUrl.genericCompetency.save, id).pipe(
      catchError(this.handleError<any>('data'))
    );
  }


  deleteOccupationSpecificCompetency(id: string) {
    return this.httpClient.post<any>(this.apiUrl.genericCompetency.save, id).pipe(
      catchError(this.handleError<any>('data'))
    );
  }


  deleteSectorSpecificCompetency(id: string) {
    return this.httpClient.post<any>(this.apiUrl.genericCompetency.save, id).pipe(
      catchError(this.handleError<any>('data'))
    );
  }

}
